const getMediaUrl = (media) =>
  media && media.length > 1 && !media.startsWith("https://")
    ? `${process.env.GATSBY_MEDIA_URL}${media}`
    : media

export default getMediaUrl
